import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface AgentData {
  agentUuid: string;
  agentTitle: string;
  runUuid: string;
}

export function useRunningAgents(
  options?: any
): UseQueryResult<AgentData[], Error> {
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['running-agents'],
    queryFn: async () => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/get_running_agents`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
        }
      );

      const data = await response.json();

      // Add some test data if no data is returned
      if (Array.isArray(data?.data) && data.data.length > 0) {
        return data.data;
      }
      // Test data
      return [
        {
          agentUuid: '124a38ba-2c47-4d29-9234-39631f5009f5',
          agentTitle: 'Test Agent 1',
          runUuid: 'run-uuid-1',
        },
        {
          agentUuid: '124a38ba-2c47-4d29-9234-39631f5009f5',
          agentTitle: 'Test Agent 2',
          runUuid: 'run-uuid-2',
        },
      ];
    },
    ...options,
  });
}
